import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxCollection, RxDatabase, RxJsonSchema } from 'rxdb'
import { createCollection } from "@/data/utils/migration.ts";

export const MODIFIER_SYNC_COLLECTION_NAME = 'modifier_sync'

export const VERSION = 1
const schema = {
  title: 'modifier sync schema',
  version: VERSION,
  primaryKey: '_id',
  type: 'object',
  properties: {
    _id: { type: 'string', maxLength: 24 },
    sync_source: { type: 'string' },
    sync_target: { type: 'string' },
    deviceId: { type: 'string' },
  },
  required: ['_id', 'sync_source', 'sync_target', 'deviceId'],
} as const satisfies RxJsonSchema<any>

export interface ModifierSync extends ExtractDocumentTypeFromTypedRxJsonSchema<typeof schema> {}
export const ModifierSync = {} as RxCollection<ModifierSync>

export const createModifierSyncCollection = async <T>(database: RxDatabase<T>) => {
  return await createCollection({
    database,
    collection: ModifierSync,
    collectionName: MODIFIER_SYNC_COLLECTION_NAME,
    version: VERSION,
    schema: schema,
  });
}
